import useSWR from 'swr';
import { SubmissionCountsResponse } from 'typings/event';

export const useAbstractsCount = (userId: string) => {
  const { data, error, ...rest } = useSWR<SubmissionCountsResponse>([
    `/abstract-management/abstracts/count?authors=${userId}`,
    true
  ]);

  return {
    ...rest,
    data: data || ({} as SubmissionCountsResponse),
    error,
    hasError: Boolean(error),
    isLoading: !data && !error
  };
};
